import { useContext } from 'react';
import { OwnCertificateContext, IOwnCertificateContext } from '../contexts/OwnCertificateContext';

export const useOwnCertificates = (): IOwnCertificateContext => {
  return useContext(OwnCertificateContext);
};
